import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';
import { installationPointPhotosKey } from '@services/useInstallationPointPhotosQuery';

import type { GalleryPhotoType } from '../constants/sensorGalleryType';
import { equipmentImagesListKey } from './useEquipmentImagesListQuery';

export interface IUpdateEquipmentImagesListData {
  id: number | string;
  imageType: GalleryPhotoType;
  installationPointIds?: number[] | null;
}

const updateEquipmentImagesListFn = ({
  equipment_Id,
  data,
}: {
  equipment_Id?: string;
  data: IUpdateEquipmentImagesListData[];
}) => {
  return apiClient.patch(`${APP_API_URL_V2}fsd/equipment/${equipment_Id}/photos/batch`, {
    photos: data,
  });
};
export const useUpdateEquipmentImagesListMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateEquipmentImagesListFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [equipmentImagesListKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [installationPointPhotosKey()[0]] });
    },
  });
};
